import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import { Grid } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import FormHelperText from "@mui/material/FormHelperText";
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";

import UiInput from "../../../../../_uiComponents/UiInput";

import { UiRadioBtn } from "../../../../../_uiComponents/common/form/UiRadioBtn";

import UiSwitch from "../../../../../_uiComponents/common/form/UiSwitch";
import MultiSelect from "../../../../../_uiComponents/common/form/MultiSelect";
import {
     UiButton,
     UiBackButton,
} from "../../../../../_uiComponents/common/form/UiButton";
import UiSelect from "../../../../../_uiComponents/common/form/UiSelect";
import UiDateRangePicker from "../../../../../_uiComponents/common/form/UiDateRangePicker";
import HierarchyDataGrid from "../../HierarchyDataGrid";
import Validator from "../../../../../../_helpers/validate.schema";
import {
     campaignTypesRequest,
     getCampaignParticipantsRequest,
     getCampaignSalesRequest,
     getCampaignTemplateTypeRequest,
     getCampaignProductRequest,
     participantListRequest,
     creationStepOneRequest,
     getAboutCampaignStepOneRequest,
     listCampaignParticipantsRequest,
} from "../../../../../../_redux/_actions";
import AccordionComponent from "../../../../../_uiComponents/common/AccordionComponent";
import CampaignAdminGrid from "./CampaignAdminGrid";
import AboutCampaignForm from "./forms/AboutCampaignForm";
import AddParticipantsForm from "./forms/AddParticipantsForm";
import ConfigureDateTemplateFrom from "./forms/ConfigureDateTemplateFrom";
import {
     FORM_TYPE_ADD,
     FORM_TYPE_EDIT,
} from "../../../../../../_helpers/constants";

export default function Campaign(props) {
     const { id } = useParams();
     
     const actionDispatch = useDispatch();

     useEffect(() => {
          if (typeof id != "undefined") {
               actionDispatch(getAboutCampaignStepOneRequest({ id }));
          }
     }, []);

     

     return (
          <>
               <AboutCampaignForm
                    activeStep={props.activeStep}
                    type={
                         typeof id != "undefined"
                              ? FORM_TYPE_EDIT
                              : FORM_TYPE_ADD
                    }
               />
               {/* <ConfigureDateTemplateFrom activeStep={props.activeStep} /> */}
               <AddParticipantsForm id={id} />

               {/* <CampaignAdminGrid id={id} /> */}
          </>
     );
}
